import { BaseResource } from "./BaseResource";
import { apiResourceUrl } from "@ploy-lib/core";
import flow from "lodash/fp/flow";
import zipWith from "lodash/fp/zipWith";
function makeEnumAsList(someEnumType) {
    const keys = Object.keys(someEnumType).filter(k => typeof someEnumType[k] === "number"); // ["A", "B"]
    const values = keys.map(k => someEnumType[k]); // [0, 1]
    return zipWith((k, v) => ({
        key: k,
        value: v
    }))(keys, values);
}
function makeEnumAsLookup(someEnumType) {
    const keys = Object.keys(someEnumType).filter(k => typeof someEnumType[k] === "number"); // ["A", "B"]
    const values = keys.map(k => someEnumType[k]); // [0, 1]
    return flow(zipWith((v, k) => [v, k]), Object.fromEntries)(values, keys);
}
export var IntegrationVendorAccessMode;
(function (IntegrationVendorAccessMode) {
    IntegrationVendorAccessMode[IntegrationVendorAccessMode["NotSet"] = 0] = "NotSet";
    IntegrationVendorAccessMode[IntegrationVendorAccessMode["LimitVendorsToExplicitlyAllowed"] = 1] = "LimitVendorsToExplicitlyAllowed";
    IntegrationVendorAccessMode[IntegrationVendorAccessMode["MappedVendorAndSalesperson"] = 2] = "MappedVendorAndSalesperson";
    IntegrationVendorAccessMode[IntegrationVendorAccessMode["AllVendors"] = 3] = "AllVendors";
    IntegrationVendorAccessMode[IntegrationVendorAccessMode["ExplicitVendorAndSalesperson"] = 4] = "ExplicitVendorAndSalesperson";
})(IntegrationVendorAccessMode || (IntegrationVendorAccessMode = {}));
export const IntegrationVendorAccessModeList = makeEnumAsList(IntegrationVendorAccessMode);
export const IntegrationVendorAccessModeLookup = makeEnumAsLookup(IntegrationVendorAccessMode);
export var IntegrationEntityMode;
(function (IntegrationEntityMode) {
    IntegrationEntityMode[IntegrationEntityMode["NotSet"] = 0] = "NotSet";
    IntegrationEntityMode[IntegrationEntityMode["Vendor"] = 1] = "Vendor";
    IntegrationEntityMode[IntegrationEntityMode["Salesperson"] = 2] = "Salesperson";
})(IntegrationEntityMode || (IntegrationEntityMode = {}));
export const IntegrationEntityModeList = makeEnumAsList(IntegrationEntityMode);
export const IntegrationEntityModeLookup = makeEnumAsLookup(IntegrationEntityMode);
export var IntegrationPropertyMode;
(function (IntegrationPropertyMode) {
    IntegrationPropertyMode[IntegrationPropertyMode["NotSet"] = 0] = "NotSet";
    IntegrationPropertyMode[IntegrationPropertyMode["Other"] = 1] = "Other";
    IntegrationPropertyMode[IntegrationPropertyMode["MembershipId"] = 2] = "MembershipId";
    IntegrationPropertyMode[IntegrationPropertyMode["SalespersonId"] = 3] = "SalespersonId";
})(IntegrationPropertyMode || (IntegrationPropertyMode = {}));
export const IntegrationPropertyModeList = makeEnumAsList(IntegrationPropertyMode);
export const IntegrationPropertyModeLookup = makeEnumAsLookup(IntegrationPropertyMode);
export var IntegrationValueMode;
(function (IntegrationValueMode) {
    IntegrationValueMode[IntegrationValueMode["NotSet"] = 0] = "NotSet";
    IntegrationValueMode[IntegrationValueMode["RawString"] = 1] = "RawString";
    IntegrationValueMode[IntegrationValueMode["Boolean"] = 2] = "Boolean";
})(IntegrationValueMode || (IntegrationValueMode = {}));
export const IntegrationValueModeList = makeEnumAsList(IntegrationValueMode);
export const IntegrationValueModeLookup = makeEnumAsLookup(IntegrationValueMode);
export class IntegrationClientResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.enabled = false;
        this.vendorAccessMode = IntegrationVendorAccessMode.NotSet;
        this.entitySettings = [];
    }
    pk() {
        return this.integrationClientId?.toString();
    }
    static merge(first, second) {
        return second;
    }
}
IntegrationClientResource.urlTemplates = [
    apiResourceUrl("vendors/{vendorId}/defaultSalespersonIntegrations")
];
IntegrationClientResource.urlRoot = apiResourceUrl("integrationClients");
//# sourceMappingURL=IntegrationClientResource.js.map